import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { idpEndpoints } from "../../Routes/api/Endpoints";
import {
  logout,
  selectGlobalToken,
  setGlobalAccessToken,
  setGlobalRefreshToken,
} from "../../redux/features/userSliceWithTokenValidation";
import { apiIdp } from "../../Routes/api/global_vars";

const baseQuery = fetchBaseQuery({
  baseUrl: apiIdp,
  prepareHeaders: (headers, { getState }) => {
    const token = selectGlobalToken(getState());
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    const refreshToken = api.getState().auth.global_refresh_token;

    if (refreshToken) {
      const refreshResult = await baseQuery(
        {
          url: idpEndpoints.getRefreshToken,
          method: "POST",
          body: { refresh: refreshToken },
        },
        api,
        extraOptions
      );

      if (refreshResult?.data) {
        const newAccessToken = refreshResult.data.access;
        const newRefreshToken = refreshResult.data.refresh;

        api.dispatch(setGlobalAccessToken(newAccessToken));
        api.dispatch(setGlobalRefreshToken(newRefreshToken));

        result = await baseQuery(args, api, extraOptions);
      } else {
        api.dispatch(logout());
      }
    } else {
      api.dispatch(logout());
    }
  }

  return result;
};

export const API_IDP = createApi({
  reducerPath: "api_idp",
  baseQuery: baseQueryWithReauth,
  refetchOnReconnect: true,
  keepUnusedDataFor: 60000,
  tagTypes: ["dataIDP"],
  endpoints: (builder) => ({
    postData: builder.mutation({
      query: ({ endpoint, elementID, formData }) => ({
        url: `${endpoint}${elementID}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["dataIDP"],
    }),
    getData: builder.query({
      query: ({ endpoint, projectId }) => {
        if (projectId) {
          return `${endpoint}${projectId}`;
        }
        return endpoint;
      },
      providesTags: ["dataIDP"],
    }),
  }),
});

export const {
    useGetDataQuery,
    usePostDataMutation,
} = API_IDP;

export default API_IDP;
